/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { smallerDependencies } from './dependenciesSmaller.generated';
import { createImmutableDenseMatrixClass } from '../../factoriesAny.js';
export var ImmutableDenseMatrixDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  smallerDependencies: smallerDependencies,
  createImmutableDenseMatrixClass: createImmutableDenseMatrixClass
};